import VueRouter, { RouteConfig } from 'vue-router'
import { DateWrapper } from 'kuaidong-lib'
import { HomeworkSummaryType } from 'kuaidong-model'

const EpIntro = () => import('../views/exercise-prescription/Intro.vue')
const EpCheckPage = () => import('../views/exercise-prescription/Check.vue')
const EpClazzTrainingDetailPage = () => import('../views/exercise-prescription/ClazzTrainingDetail.vue')
const EpStudentTrainingRecord = () => import('../views/exercise-prescription/EPStudentTrainingRecord.vue')
const EpComment = () => import('../views/exercise-prescription/EPComment.vue')
const EpTopStudent = () => import('../views/exercise-prescription/EPTopStudents.vue')

const epCheckRouter: RouteConfig = {
  path: '/ep-check',
  name: 'ep_check',
  component: EpCheckPage,
  props: (route) => ({ ...route.query, ...route.params }),

  meta: {
    title: '检查训练',
  },
}

const epClazzTrainingDetailRouter: RouteConfig = {
  path: '/ep-clazz-training-detail',
  name: 'ep_clazz_training_detail',
  component: EpClazzTrainingDetailPage,
  props: (route) => {
    const result = {
      query: route.query.query ? JSON.parse(`${route.query.query}`) : null,
    }

    if (result.query && result.query.date) {
      result.query.date = new DateWrapper(result.query.date).date
      result.query.clazzId = Number(result.query.clazzId)
    }
    return { ...result.query }
  },
  meta: {
    title: '训练详情',
  },
}

const epStudentTrainingRecordRouter: RouteConfig = {
  path: '/ep-student-training-detail',
  name: 'ep_student_training_detail',
  component: EpStudentTrainingRecord,
  props: (route) => {
    const result = {
      query: route.query.query ? JSON.parse(`${route.query.query}`) : null,
    }

    if (result.query && result.query.date) {
      result.query.date = new DateWrapper(result.query.date).date
      result.query.clazzId = Number(result.query.clazzId)
    }
    return { ...result.query }
  },
  meta: {
    title: '个人训练记录',
  },
}

const epIntroRouter: RouteConfig = {
  path: '/ep-intro',
  name: 'ep_intro',
  component: EpIntro,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '运动处方',
  },
}

const epCommentRouter: RouteConfig = {
  path: '/ep-comment',
  name: 'ep_comment',
  component: EpComment,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '批改作业',
  },
}

const epTopStudentRouter: RouteConfig = {
  path: '/ep-top-student',
  name: 'ep_top_student',
  component: EpTopStudent,
  props: (route) => {
    const result = {
      query: route.query.query ? JSON.parse(`${route.query.query}`) : null,
    }

    if (result.query && result.query.date) {
      result.query.date = new DateWrapper(result.query.date).date
    }
    return { ...result.query }
  },
  meta: {
    title: '优秀名单',
  },
}
export default [
  epCheckRouter,
  epClazzTrainingDetailRouter,
  epStudentTrainingRecordRouter,
  epIntroRouter,
  epCommentRouter,
  epTopStudentRouter,
]

export function navigateToEpCheck(router: VueRouter, date?: string) {
  router.push({ name: epCheckRouter.name, query: { date } })
}
export function navigateToEpClazzDetail(
  router: VueRouter,
  clazzId: number,
  clazzName: string,
  date: Date,
  type: HomeworkSummaryType
) {
  router.push({
    name: epClazzTrainingDetailRouter.name,
    query: {
      query: JSON.stringify({
        clazzId,
        clazzName,
        date,
        type,
      }),
    },
  })
}

export function navigateToEpStudentTrainingDetail(
  router: VueRouter,
  userId: number,
  date: Date,
  type: HomeworkSummaryType,
  clazzName: string,
  clazzId: number,
  filterItem: string
) {
  router.push({
    name: epStudentTrainingRecordRouter.name,
    query: {
      query: JSON.stringify({
        userId: `${userId}`,
        date,
        type,
        clazzName,
        clazzId,
        filterItem,
      }),
    },
  })
}

export function navToEpTopStudent(
  router: VueRouter,
  date: Date,
  type: HomeworkSummaryType,
  clazzId: number,
  clazzName: string
) {
  router.push({
    name: epTopStudentRouter.name,
    query: {
      query: JSON.stringify({
        date,
        type,
        clazzId,
        clazzName,
      }),
    },
  })
}

export function navigateToEpIntro(router: VueRouter) {
  router.push({ name: epIntroRouter.name })
}

export function navigateToEpComment(router: VueRouter, recipeDayId: string, userId: string) {
  router.push({
    name: epCommentRouter.name,
    query: {
      recipeDayId,
      userId,
    },
  })
}
